import { Navigate, createFileRoute, useParams } from '@tanstack/react-router';
import { importIsInvalid } from '@/services/db/collection/entity';
import { useCollection } from '@/services/db/collection/queries';
import { useWorkspaceIdFromCurrentUrl } from '@/services/router/use-workspace-id';
import { LazyPage } from './-route-layouts';

export function CollectionDetailIndexRoute() {
  const { collectionId } = useParams({ strict: false });
  const workspaceId = useWorkspaceIdFromCurrentUrl() ?? 0;
  const { data: collection } = useCollection({ id: collectionId ?? '' });

  if (importIsInvalid(collection)) {
    return <Navigate to="/workspaces/$workspaceId/collections" params={{ workspaceId }} replace={true} />;
  }

  const route = collection.importing
    ? '/workspaces/$workspaceId/collections/$collectionId/importing'
    : '/workspaces/$workspaceId/collections/$collectionId/data';

  return <Navigate to={route} params={{ workspaceId, collectionId: collection.id }} replace={true} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/collections/$collectionId/')({
  component: () => (
    <LazyPage>
      <CollectionDetailIndexRoute />
    </LazyPage>
  ),
});
